<template>
  <div class="relative aspect-[390/844] rounded-[12.5%/5.8%] border border-white/20 bg-neutral-950 p-[3.2%] shadow-2xl shadow-black/70">
    <!-- the screen: whatever goes in the slot fills it -->
    <div class="relative size-full overflow-hidden rounded-[10%/4.8%] bg-neutral-900">
      <slot />
    </div>
    <!-- dynamic island -->
    <span class="absolute left-1/2 top-[3.3%] z-10 h-[2.9%] w-[29%] -translate-x-1/2 rounded-full bg-black" />
  </div>
</template>
